import './DatePicker.css';
import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { addYears } from "date-fns";
import { ar, ru, cs, nl, fi, de, ja, nb, pt, sv, zhCN, da, fr, it, ko, pl, ro, es, uk, tr, enUS } from 'date-fns/locale';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
import { ReactComponent as IconPlane } from '../../../resources/icons/iconPlane.svg';
import { emptyDateShowObj } from '../index';
const langHash = {
  ar: ar,
  ru: ru,
  cs: cs,
  nl: nl,
  fi: fi,
  de: de,
  ja: ja,
  no: nb,
  pt: pt,
  sv: sv,
  zh: zhCN,
  da: da,
  fr: fr,
  it: it,
  ko: ko,
  pl: pl,
  ro: ro,
  es: es,
  uk: uk,
  tr: tr,
  en: enUS
};
const DatePickerDropDown = _ref => {
  let {
    lang,
    rtl,
    dateOpened,
    closeDateDropdown,
    depDate,
    setDepDate,
    retDate,
    setRetDate,
    resetFlag,
    setResetFlag,
    returnTicket,
    setReturnTicket,
    textClear,
    oneWayText,
    datesAvailable,
    isMobile,
    enableAmountOpenFlag,
    mobileStateSelectDepartureDateText,
    mobileStateSelectReturnDateText,
    mobilePlaceholderDepartureDateText,
    mobilePlaceholderReturnDateText,
    mobileStateDepartureDateSelectedText,
    mobileStateDepartureReturnDateSelectedText
  } = _ref;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [singleDate, setSingleDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [availableDatesIndex, setAvailableDatesIndex] = useState(0);
  const renderTooltipText = () => {
    return !returnTicket || !startDate || startDate && endDate ? mobilePlaceholderDepartureDateText : mobilePlaceholderReturnDateText;
  };
  const renderDayContents = (day, date) => {
    return /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__day-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__tooltip"
    }, renderTooltipText()), date.getDate());
  };
  const setDayClassName = date => {
    if (datesAvailable[availableDatesIndex].length) {
      return datesAvailable[availableDatesIndex].includes(date.toLocaleString('sv').replace(' ', 'T')) ? '' : 'react-datepicker__day--unscheduled';
    }
    return '';
  };
  const renderCustomHeader = props => {
    const {
      monthDate,
      decreaseMonth,
      increaseMonth,
      customHeaderCount,
      nextMonthButtonDisabled,
      prevMonthButtonDisabled
    } = props;
    return /*#__PURE__*/React.createElement("div", {
      className: "react-datepicker__header-month"
    }, /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__current-month"
    }, monthDate.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
      month: "long",
      year: "numeric"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Previous Month",
      className: `
          react-datepicker__navigation react-datepicker__navigation--previous
          ${isMobile ? 'd-none' : ''}
          ${customHeaderCount !== 0 || prevMonthButtonDisabled ? 'd-none' : ''}
        `,
      onClick: decreaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowLeft, {
      className: "icon"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Next Month",
      className: `
          react-datepicker__navigation react-datepicker__navigation--next
          ${isMobile ? 'd-none' : ''}
          ${customHeaderCount !== 1 || nextMonthButtonDisabled ? 'd-none' : ''}
        `,
      onClick: increaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowRight, {
      className: "icon"
    })));
  };
  const generateDateObj = date => date ? {
    day: date.toLocaleString(undefined, {
      day: "numeric"
    }),
    dayNumber: date.toLocaleString(undefined, {
      day: "2-digit"
    }),
    month: date.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
      month: "long"
    }),
    monthNumber: date.toLocaleString('en-US', {
      month: "2-digit"
    }),
    year: date.toLocaleString(undefined, {
      year: "numeric"
    })
  } : emptyDateShowObj;
  const renderDatePickerTitle = () => {
    if (returnTicket) {
      if (startDate && endDate) return mobileStateDepartureReturnDateSelectedText;
      if (startDate) return mobileStateSelectReturnDateText;
    }
    if (!returnTicket) {
      if (singleDate) return mobileStateDepartureDateSelectedText;
    }
    return mobileStateSelectDepartureDateText;
  };
  useEffect(() => {
    if (!singleDate && !startDate && !endDate || startDate && endDate || singleDate) {
      setAvailableDatesIndex(0);
      return;
    }
    if (startDate && !endDate) {
      setAvailableDatesIndex(1);
      return;
    }
    setAvailableDatesIndex(0);
  }, [singleDate, startDate, endDate, datesAvailable]);
  useEffect(() => {
    if (returnTicket) {
      if (singleDate) {
        setSingleDate(null);
        setStartDate(singleDate);
        setEndDate(singleDate);
        setMinDate(singleDate);
        return;
      }
      if (startDate) {
        setDepDate(generateDateObj(startDate));
        setRetDate(generateDateObj(endDate));
        setMinDate(endDate ? new Date() : startDate);
        return;
      }
    }
    if (startDate) {
      setSingleDate(startDate);
      setStartDate(null);
      setEndDate(null);
      return;
    }
    if (singleDate) {
      setDepDate(generateDateObj(singleDate));
      setRetDate(generateDateObj(singleDate));
      return;
    }
    setDepDate(generateDateObj(null));
    setRetDate(generateDateObj(null));
    setMinDate(new Date());
  }, [returnTicket, startDate, endDate, singleDate]);
  useEffect(() => {
    if (resetFlag) {
      setResetFlag(false);
      setStartDate(null);
      setEndDate(null);
      setSingleDate(null);
    }
  }, [resetFlag]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    opened: dateOpened
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-close d-none d-md-block",
    onClick: () => {
      closeDateDropdown();
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: () => {
      closeDateDropdown();
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, renderDatePickerTitle()), (startDate || singleDate) && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: () => {
      setResetFlag(true);
    }
  }, textClear)), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-state-area"
  }, /*#__PURE__*/React.createElement("div", {
    className: `
          dropdown-state-area__cell
          ${returnTicket && !startDate && !endDate ? 'dropdown-state-area__cell--active' : ''}
          ${!returnTicket && !singleDate ? 'dropdown-state-area__cell--active' : ''}
        `
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: `dropdown-state-area__label ${depDate.day ? 'dropdown-state-area__label--selected' : ''}`
  }, mobilePlaceholderDepartureDateText), depDate.day && /*#__PURE__*/React.createElement("div", {
    className: "d-flex dropdown-state-area__date"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-day"
  }, depDate.day), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-month"
  }, depDate.month, /*#__PURE__*/React.createElement("br", null), depDate.year)))), returnTicket && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__plane-icon"
  }, /*#__PURE__*/React.createElement(IconPlane, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: `
              dropdown-state-area__cell
              ${returnTicket && startDate && !endDate ? 'dropdown-state-area__cell--active' : ''}
            `
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: `dropdown-state-area__label ${retDate.day ? 'dropdown-state-area__label--selected' : ''}`
  }, mobilePlaceholderReturnDateText), retDate.day && /*#__PURE__*/React.createElement("div", {
    className: "d-flex dropdown-state-area__date"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-day"
  }, retDate.day), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__date-month"
  }, retDate.month, /*#__PURE__*/React.createElement("br", null), retDate.year)))))), /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body__head-wrapper d-none d-md-flex"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "datepicker-body__head"
  }, renderDatePickerTitle()), /*#__PURE__*/React.createElement("label", {
    className: "datepicker-body__checkbox-label"
  }, /*#__PURE__*/React.createElement("input", {
    className: "datepicker-body__checkbox",
    type: "checkbox",
    checked: !returnTicket,
    onChange: () => {
      setReturnTicket(!returnTicket);
    }
  }), oneWayText)), /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    monthsShown: isMobile ? 13 : 2,
    locale: langHash[lang],
    useWeekdaysShort: true,
    renderCustomHeader: renderCustomHeader,
    startDate: startDate,
    endDate: endDate,
    selected: singleDate,
    selectsRange: returnTicket,
    minDate: returnTicket ? minDate : new Date(),
    maxDate: addYears(new Date(), 1),
    renderDayContents: renderDayContents,
    dayClassName: setDayClassName,
    onChange: date => {
      if (Array.isArray(date)) {
        setStartDate(date[0]);
        setEndDate(date[1]);
        if (date[1]) {
          closeDateDropdown();
          enableAmountOpenFlag();
        }
      } else {
        setSingleDate(date);
        closeDateDropdown();
        enableAmountOpenFlag();
      }
    }
  })));
};
const commonStyles = "c4px577";
const ltrStyles = "l1dmtmnl";
const rtlStyles = "r16eem4s";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    opened
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `
  datepicker-dropdown
  ${commonStyles}
  ${rtl ? rtlStyles : ltrStyles}
  ${opened ? 'datepicker-dropdown--opened' : ''}
`
  }, children);
};
export default DatePickerDropDown;